import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  languagesViewColumns,
  mapLanguagesViewQuery,
} from "./LanguagesView.default";
import { getLanguages } from "../repository/data.repository";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createGridRequest } from "../hooks/useGridRequest";

export interface LanguagesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function LanguagesView(props: LanguagesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={languagesViewColumns}
      mapQuery={mapLanguagesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getLanguages, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "name", label: "Name" },
              { type: "textbox", name: "code", label: "Code" },
              { type: "textbox", name: "alpha3Code", label: "Alpha-3 Code" },
            ],
          },
        ],
      }}
      actions={(_record) => [
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Languages", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          disabled: !permissions.can("Languages", "delete"),
          danger: true,
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default LanguagesView;
